import MainLayout from 'Components/Globals/Layout/MainLayout/loadable';
import AuthLayout from 'Components/Globals/Layout/AuthLayout/loadable';
import InternalLayout from 'Components/Globals/Layout/InternalLayout/loadable';
import SimpleLayout from 'Components/Globals/Layout/simpleLayout/loadable';
import LayoutWithoutHeader from 'Components/Globals/Layout/LayoutWithoutHeader/loadable';

const layouts = {
	default: {
		name: 'default',
		element: MainLayout,
	},
	authentication: {
		name: 'authentication',
		element: AuthLayout,
	},
	internal: {
		name: 'internal',
		element: InternalLayout,
	},
	simple: {
		name: 'simple',
		element: SimpleLayout,
	},
	withoutHeader: {
		name: 'withoutHeader',
		element: LayoutWithoutHeader,
	},
	light: 'light',
};

export default layouts;
